module.exports = __webpack_public_path__ + "static/media/ckn_historial_detalle.7a526f96.jpg";